import SearchNotFoundIllustration from 'components/Icons/illustrations/search/notFound.svg';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

const PriceWidgetExtrasEmptyView: FunctionComponent = () => {
  const { t } = useTranslation('vehicle');
  return (
    <div className="mx-auto mt-6 flex max-w-md flex-col items-center gap-6">
      <SearchNotFoundIllustration className="inline-block w-60" />
      <span className="text-center text-18px font-medium">
        {t('priceWidget.emptyExtras')}
      </span>
    </div>
  );
};

export default PriceWidgetExtrasEmptyView;
